import { Readability, SentenceDTO } from '@/utils/types/common';

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IDocumentComponent {
  _id: string;
  type: 'Header' | 'Paragraph';
}

export type DocumentComponent = DocumentHeader | DocumentParagraph;

export interface DocumentHeader extends IDocumentComponent {
  _id: string;
  type: 'Header';
  title: string;
  level: number;
  parentId?: string;
  childrenIds: string[];
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IDocumentParagraph extends IDocumentComponent{
  _id: string;
  type: 'Paragraph';
  parentId: string;
  readability: Readability;
}

export interface DocumentParagraph extends IDocumentParagraph {
  _id: string;
  sentences: SentenceDTO[];
  parentId: string;
  parents: DocumentHeader[];
  readability: Readability;
}

const findParentsChain = (headers: DocumentHeader[], parentId?: string): DocumentHeader[] => {
  if (parentId) {
    const parent = headers.find((h) => h._id === parentId);
    if (parent) {
      return [
        parent as DocumentHeader,
        ...findParentsChain(headers, parent?.parentId),
      ];
    }
    return [];
  }
  return [];
};

export const createDocumentParagraphs = (components: DocumentComponent[]): DocumentParagraph[] => {
  const paragraphs = components.filter(
    (c) => c.type === 'Paragraph',
  ) as IDocumentParagraph[];

  const headers = components.filter(
    (c) => c.type === 'Header',
  ) as DocumentHeader[];

  return paragraphs.map((p) => ({
    ...p,
    parents: findParentsChain(headers, p.parentId),
  }) as DocumentParagraph);
};
